import * as MixPanel from './mixpanel';

export const trackInit = ({ mixId }) => {
  if (mixId) {
    MixPanel.init(mixId);
    MixPanel.reset();
  }
};

export const trackIdentifyUser = data => {
  MixPanel.identify(data);
};

export const trackPageView = () => {
  MixPanel.trackPageView();
};

export const trackEvent = (event, data) => {
  MixPanel.trackEvent(event, data);
};
